// extracted by mini-css-extract-plugin
export default {"movieList":"MovieList_movieList__pH29x"};